import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import withAuthorization from '../withAuthorization';
import { auth, firebase, db } from '../../firebase';
import * as routes from '../../constants/routes';
import logo from '../../assets/logo.png';
import httpreq from '../utils/Api';
import * as apiRoutes from '../../constants/apiRoutes';
import  './SelectInterests.css';



const SelectInterestsPage = ({history}) => 
  <div className="container">
    <div className="text-center">
      <img src={logo} />
    </div>
    <SelectInterestsForm history={history}/>
  </div>

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  topics: [],
  selectedTopics: [],
  token: '',
  error: null,
};

class SelectInterestsForm extends Component {

  constructor(props) {
    super(props);

    this.state = { 
      ...INITIAL_STATE
    };
  }

  getThis() {
    return this;
  }

  onSubmit = (event) => {
    const {
      selectedTopics
    } = this.state;
    const {
      history,
    } = this.props;
    const reqBody = {'topics': selectedTopics};
    
    auth.getAuthToken()
    .then((tokenId) => {
      if(!tokenId) {
        console.error('User Not Authorized');
        this.setState(byPropKey('error', 'User Not Authorized'));
      }
      else {
        httpreq({
          method: 'PUT',
          url: apiRoutes.SAVE_TOPICS,
          headers: {'Content-type': 'application/json', 'token': tokenId},
          data: reqBody
        })
        .then((res) => {
            history.push('/');
        })
        .catch(error => {
          if(error.errorMessage) {
            this.setState(byPropKey('error', error.errorMessage));
          }
        })
      }
    })

    event.preventDefault();
  }

  handleChecked = (event) => {
    if (event.target.checked) {
      this.setState({
        selectedTopics: this.state.selectedTopics.concat(event.target.value.toString())
      });
    } else {
      this.setState({
        selectedTopics: this.state.selectedTopics.filter(function(topic) { 
          return topic !== event.target.value.toString();
        }
      )
    });
    }
  }

  isPresent(val) {
    return this.state.selectedTopics.includes(val.toString());
  }

  componentDidMount() {
    httpreq({
      method: 'GET',
      url: apiRoutes.GET_TOPICS,
      headers: {'Content-type': 'application/json'}
    })
    .then(res => {
      this.setState({topics: res['topics']});
    }) 
  }

  render() {
    const {
      topics,
      selectedTopics,
      error,
    } = this.state;

    const isInvalid = selectedTopics.length === 0;

    return (
      <div>
        <form className="featureFormLayout" onSubmit={this.onSubmit}>
        <div className="circularWrapper">
        { 
          topics.map((topic, index )=> (
            <div key={index} className="circularCheckboxes d-flex align-items-center">
            <label htmlFor={topic.id}>
              <input
                type="checkbox"
                id={topic.id}
                value={topic.id}
                checked={this.isPresent(topic.id)}
                onChange={this.handleChecked}
              />
              <span className="checkTxt">{topic.name}</span>
            </label>
            </div>
          ))
        }
        </div>
        <div className="featureButtonCont">
        <button 
          className="btn btn-lg kinnected-orange" 
          id="create-button" 
          disabled={isInvalid} 
          type="submit"
        >
          Complete
        </button>
        </div>

          {error && <p>{error}</p>}
        </form>
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;

export default withAuthorization(authCondition)(withRouter(SelectInterestsPage));



// WEBPACK FOOTER //
// ./src/components/account/SelectInterests.js